<template>
    <div class="box-modal">
     <div class="box-modal-body">
        <div class="box-error">
          
          <div class="tab">
            <button class="tablinks" :class="this.btnType === 'btn1' ? 'active' : ''" @click="openCity('btn1')">Танилцуулга</button>
            <button class="tablinks" :class="this.btnType === 'btn2' ? 'active' : ''" @click="openCity('btn2')">Заавар</button>
            <button class="tablinks" :class="this.btnType === 'btn3' ? 'active' : ''" @click="openCity('btn3')">Нөхцөл</button>
          </div>
            <div id="btn1" class="tabcontent" style="display:block;">
              <h2>Бонус шилжүүлгийн үйлчилгээ</h2>
              <p style="margin-top:10px;padding-bottom: 10px;"><img src="@/assets/icon/exchange.png" alt=""> Бонус шилжүүлэг үйлчилгээ гэж юу бэ?</p>
              <div class="divBox">
                  <p>Та өөрийн НОМИН бонус данснаас бусад НОМИН бонус данстай найз нөхөд гэр бүлийн хүмүүс руугээ НОМИН Бонус оноогоо шилжүүлэх буюу бэлэглэх үйлчилгээг хэлнэ.</p>
              </div>
              <p style="margin-top:10px;padding-bottom: 10px;"><img src="@/assets/icon/exchange.png" alt=""> Бонус шилжүүлэг үйлчилгээ гэж юу бэ?</p>
              <div class="divBox2">
                  <ul>
                      <li><img src="@/assets/icon/success.png" alt=""><p>Хэзээ ч хаанаас ч бонус оноогоо бусад карт эзэмшигч рүү шилжүүлэх боломжтой.</p></li>
                      <li><img src="@/assets/icon/success.png" alt=""><p>Өдөрт 3 удаа шилжүүлэг хийх боломжтой.</p></li>
                      <li><img src="@/assets/icon/success.png" alt=""><p>1 удаа шилжүүлэх боломжтой дээд бонус оноо 500,000 байна.</p></li>
                      <li><img src="@/assets/icon/success.png" alt=""><p>Цаг хугацаа орон зайнаас үл хамаарна.</p></li>
                      <li><img src="@/assets/icon/success.png" alt=""><p>Худалдан авалт, гүйлгээний хуулга тогтмол хянана.</p></li>
                      <li><img src="@/assets/icon/success.png" alt=""><p>Бонус оноогоо Номин-ийн бүх салбар дэлгүүрт зарцуулна.</p></li>
                  </ul>
              </div>
            </div>

            <div id="btn2" class="tabcontent">
              <p style="margin-top:20px;padding-bottom: 10px;"><img src="@/assets/icon/exchange.png" alt=""> Номин бонус оноо шилжүүлэх заавар</p>
              <div class="divBox2">
                  <ul>
                      <li><p>1. Хэрэглэгч bonus.nomin.mn руу нэвтрэн орно</p></li>
                      <li><p>2. Бонус шилжүүлэх хэсэгт хүлээн авагчийн бүртгэлтэй утасны дугаар эсвэл Бонус картны дугаарыг үнэн зөв бичнэ</p></li>
                      <li><p>3. Шилжүүлэх дүн хэсэгт шилжүүлэх бонус онооны дүнгээ оруулна </p></li>
                      <li><p>4. Гүйлгээний утга хэсэгт: Гүйлгээний утга бичээд. /Утгыг заавал оруулахгүй байж болно/ Шилжүүлэх товчийг дарна.</p></li>
                  </ul>
              </div>
            </div>

            <div id="btn3" class="tabcontent">
              <p style="margin-top:20px;padding-bottom: 10px;"><img src="@/assets/icon/exchange.png" alt=""> Номин бонус оноо шилжүүлэх заавар</p>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Үйлчилгээ</th>
                    <th>Шимтгэл хураамж</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Бонус шилжүүлэг шимтгэл</td>
                    <td>Шилжүүлж байгаа бонусын 10% байна.</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Бонус шилжүүлгийн доод дүн</td>
                    <td>1000 бонус ба түүнээс дээш оноо байна.</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Гүйлгээний хэмжээ /Бонус карттай хэрэглэгч/</td>
                    <td>1 удаа шилжүүлэг хийх доод хязгаар 1000, дээд хязгаар 500,000 бонус оноо байна.</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Шилжүүлгийн тоо</td>
                    <td>Өдөрт 3 удаа шилжүүлэг хийх боломжтой.</td>
                  </tr>
                </tbody>
              </table>
              <p style="padding-bottom: 10px;">Санамж</p>
              <div class="divBox2">
                  <ul>
                      <li><img src="@/assets/icon/danger.png" alt=""><p> 1. Бонус шилжүүлэг хийхдээ андуурч гүйлгээ хийсэн тохиолдолд шилжүүлсэн бонус оноог шимтгэлийн хамт буцаан олгох боломжгүй.</p></li>
                      <li><img src="@/assets/icon/danger.png" alt=""><p> 2. Хэрэглэгчийн шилжүүлэх дүн бутархай дүн байх үед 0.5-с дээш бол 1 бүхэл рүү доош бол 0 рүү шахаж бодохыг анхаарна уу.</p></li>
                      <li><img src="@/assets/icon/danger.png" alt=""><p> 3. Бонус шилжүүлэгийн шимтгэл бутархай дүнг бүхэл тоонд шилжүүлэн суутгана. </p></li>
                      <li><img src="@/assets/icon/danger.png" alt=""><p> 4. Хэрэглэгч та бонус оноо хүлээн авагчийн картын дугаар эсвэл утасны дугаарыг сайтар хянана уу.</p></li>
                  </ul>
              </div>
            </div>
        </div>
        <div class="box-close">
          <img src="@/assets/icon/close.png" alt="" @click.esc="close">
        </div>
     </div>
   </div>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {
      btnType: "btn1",
    };
  },
  methods: {
    close() {
      this.$emit("hideHelp");
    },
    openCity(cityName) {
      this.btnType = cityName;
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
    },
  },
};
</script>

<style scoped>
.box-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.box-modal-body {
  position: absolute;
  top: 18%;
  width: 930px;
  height: 430px;
  border-radius: 5px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  background: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
}

.box-modal-body .box-error {
  font-size: 13px;
  width: 100%;
  line-height: 1.38;
  flex: 5;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.box-modal-body .box-error h2 {
  color: #1660ab;
  text-align: center;
  font-size: 18px;
  padding-top: 10px;
}
.box-modal-body .box-error p {
  color: #1660ab;
  font-weight: bold;
}
.box-modal-body .box-error img {
  width: 18px;
  height: 20px;
  margin-right: 10px;
}
.box-modal-body div p {
  margin: 0;
}
.box-modal-body img {
  width: 100%;
  cursor: pointer;
}
.box-close {
  top: 5px;
  right: 5px;
  opacity: 1;
  position: absolute;
  background: #1660AB;
}
@media screen and (max-width: 500px) {
  .box-modal-body {
    margin-top: 90%;
  }
}
@media screen and (max-width: 800px) {
  .box-modal-body {
    margin-top: 0;
    width: 92%;
  }
  .tabcontent{
    overflow-x: scroll;
    height: 400px;
  }
  
}

/* Style the tab */
.tab {
  overflow: hidden;
  background-color: #1660ab;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 16px;
  transition: 0.3s;
  font-size: 14px;
  color: #fff;
}
.tab button.color1 {
  background: #000;
}
/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
  color: #000;
}

/* Create an active/current tablink class */
.tab .active {
  background: #fff !important;
  color: #000;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  -webkit-animation: fadeEffect 1s;
  animation: fadeEffect 1s;
  
}

/* Fade in tabs */
@-webkit-keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.divBox {
  margin: 0;
  padding: 10px;
  border: 1px solid #e4e4e4;
}
.divBox p {
  color: #000 !important;
  margin: 0;
  padding: 0;
  font-weight: 400 !important;
}
.divBox2 {
  margin: 0;
  padding: 10px;
  border: 1px solid #e4e4e4;
}
.divBox2 ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.divBox2 li {
  padding: 0;
  margin: 0;
      display: flex;
    flex-direction: row;
    width: 100%;

}
.divBox2 p {
  display: inline-block;
  color: #000 !important;
  font-weight: 400 !important;
  margin: 0;
  padding: 2px 8px;
  padding-bottom: 8px;
}
.divBox2 img {
  display: inline-block;
  width: 20px !important;
  margin: 0;
  padding: 0;
}
.table th,
.table td {
  padding: 6px;
}
</style>
